/* hs-eslint ignored failing-rules */

/* eslint-disable no-bitwise */
'use es6';

import { MAC, WINDOWS } from 'DesignData/enums/OperatingSystemTypes';
export function getOperatingSystem() {
  const {
    platform,
    userAgent
  } = navigator || {};
  return platform && ~platform.toLowerCase().indexOf('mac') || userAgent && ~userAgent.toLowerCase().indexOf('macintosh') ? MAC : WINDOWS;
}